export default __webpack_public_path__ + "static/media/6 - Iceman.966bd844.mp3";